import React, { useEffect, useState } from 'react';
import { CalendarClock, Clock, PhoneMissed, TrendingUp, AlertTriangle } from 'lucide-react';
import { retentionAPI } from '@/lib/api';

const TILES = [
  { key: 'renewals', field: 'renewals_due', label: 'Renewals / Reviews', icon: CalendarClock, color: 'text-indigo-600', bg: 'bg-indigo-50' },
  { key: 'renewals', field: 'due_soon', label: 'Due Soon (30d)', icon: Clock, color: 'text-blue-600', bg: 'bg-blue-50' },
  { key: 'needs_contact', field: 'needs_contact', label: 'Needs Contact', icon: PhoneMissed, color: 'text-amber-600', bg: 'bg-amber-50' },
  { key: 'cross_sell', field: 'cross_sell', label: 'Cross-Sell', icon: TrendingUp, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { key: 'at_risk', field: 'at_risk', label: 'At Risk', icon: AlertTriangle, color: 'text-rose-600', bg: 'bg-rose-50' },
];

// Compact KPI strip for the retention workspace. Tiles are clickable to
// jump to the matching tab.
export default function RetentionKpis({ onSelect, refreshKey }) {
  const [kpis, setKpis] = useState(null);

  useEffect(() => {
    retentionAPI.kpis().then((r) => setKpis(r.data)).catch(() => {});
  }, [refreshKey]);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5 mb-4" data-testid="retention-kpis">
      {TILES.map((t) => {
        const Icon = t.icon;
        return (
          <button
            key={t.field}
            onClick={() => onSelect?.(t.key)}
            className="flex items-center gap-2.5 rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-left hover:shadow-sm hover:border-slate-300 transition"
            data-testid={`kpi-${t.field}`}
          >
            <div className={`h-9 w-9 rounded-lg grid place-items-center ${t.bg}`}>
              <Icon className={`h-4 w-4 ${t.color}`} />
            </div>
            <div className="min-w-0">
              <div className="text-xl font-bold text-slate-900 leading-none">{kpis ? (kpis[t.field] ?? 0) : '—'}</div>
              <div className="text-[11px] text-slate-500 truncate">{t.label}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
